module.exports = __webpack_public_path__ + "img/symbol_2.280a80d7.png";